import React from "react";
import { resolveValue, useToaster } from "react-hot-toast";

export const JestToaster: React.FunctionComponent = () => {
  const { toasts } = useToaster();
  if (toasts.length === 0) {
    return null;
  }
  return (
    <>
      {toasts.map((toast) => (
        <div key={toast.id}>{resolveValue(toast.message, toast)}</div>
      ))}
    </>
  );
};
